import dynamic from 'next/dynamic'
import styles from './ctas.module.scss'
import { Size } from '@/types/system'

import { ExternalLink } from '@/components/styleguide/Link'
import { ButtonHierarchy } from '@/components/styleguide/Button'

const Icon = dynamic(() => import('@/components/styleguide/Icon'))

type CtasProps = {
  supplierCount: number
}

export const Ctas = ({ supplierCount }: CtasProps) => {

  return (
    <section className={styles['section-cta']}>
      <div className={styles.grid}>
        <div className={styles.item}>
          <Icon
            size={Size.ExtraLarge}
            name="PartyPopper"
            customClass={styles.icon}
          />
          <h3>Save £484/month vs PCP</h3>
          <p>Last year our customers saved big each month compared to other finance options for their new car.</p>
          <ExternalLink
            size={Size.Large}
            hierarchy={ButtonHierarchy.Text}
            href="https://www.leaseloco.com/pcp-savings"
            className={styles.link}
            target="_blank"
          >
            Learn more
          </ExternalLink>
        </div>
        <div className={styles.item}>
          <Icon
            size={Size.ExtraLarge}
            name="CircleCheck"
            customClass={styles.icon}
          />
          <h3>Get the best value for money</h3>
          <p>Configure your car the way you want, without ever second-guessing a good deal with our LocoScore.</p>
          <ExternalLink
            size={Size.Large}
            hierarchy={ButtonHierarchy.Text}
            href="https://www.leaseloco.com/loco-score"
            className={styles.link}
            target="_blank"
          >
            Learn more
          </ExternalLink>
        </div>
        <div className={styles.item}>
          <Icon
            size={Size.ExtraLarge}
            name="Star"
            customClass={styles.icon}
          />
          <h3>See real-time deals across the UK</h3>
          <p>With {supplierCount} providers and millions of deals you&apos;re sure to find the very best deal at LeaseLoco.</p>
          <ExternalLink
            size={Size.Large}
            hierarchy={ButtonHierarchy.Text}
            href="https://www.leaseloco.com/partner-criteria"
            className={styles.link}
            target="_blank"
          >
            Learn more
          </ExternalLink>
        </div>
      </div>
    </section>
  )
}
